// extracted by mini-css-extract-plugin
module.exports = {"textDetailBox":"ActionDetail_textDetailBox__LPK_R","prose":"ActionDetail_prose__2pXo3","dark":"ActionDetail_dark__JLjLp"};